<template lang="pug">
    .monthsList
        .arrow.left(@click="scroll('left')")
        .list(ref="list")
            .month(v-for="(month, ind) in months"
                :class="{active: activeMonth===ind}"
                @click="$emit('updateActiveMonth', ind), $scrollPageTo('.'+month.MONTH_ID)"
                v-html="month.MONTH_NAME")
        .arrow.right(@click="scroll('right')")

</template>

<script>
    export default {
        name: "MonthsList",
        props:['months', 'activeMonth', 'fixedHeaderHeight'],
        data:()=>({
            canScroll: true,
        }),
        methods:{
            scroll(dir){
                if (!this.canScroll) return;
                this.canScroll = false;
                setTimeout(()=>{
                    this.canScroll = true;
                },150);
                if (dir === 'right' && this.activeMonth < this.months.length-1){
                    this.$emit('updateActiveMonth', this.activeMonth+1)
                } else if (dir === 'left' && this.activeMonth > 0){
                    this.$emit('updateActiveMonth', this.activeMonth-1)
                }
                setTimeout(()=>{
                    this.$scrollPageTo('.'+this.months[this.activeMonth].MONTH_ID)
                })
            }
        },
        mounted() {
            /*this.$refs.list.addEventListener('wheel', (e) => {
                e.preventDefault()
                let delta = e.deltaY;
                if (delta > 0) { // вниз
                    this.scroll('right');
                } else if (delta < 0) {
                    this.scroll('left');
                }
            })*/
        }
    }
</script>

<style scoped lang="scss">
    .monthsList{
        position: relative;
    }
    .arrow{
        position: absolute;
        top: 50%;
        transform: translateY(-50%) rotate(-90deg);
        width: to_rem(14px);
        height: to_rem(14px);
        background: url(../../assets/img/arrow_1_red.png) no-repeat center center / contain;
        cursor: pointer;
        &.left{
            right: 100%;
        }
        &.right{
            left: 100%;
            transform: translateY(-50%) rotate(90deg);
        }
    }
    .list{
        display: flex;
        justify-content: space-between;
        align-items: center;
        /*width: 21.4rem;*/
        width: 100%;
        padding: 0 2rem;
        overflow: hidden;

        .month{
            display: flex;
            align-items: center;
            height: 2rem;
            font-size: to_rem(20px);
            cursor: pointer;
            transition: all .15s linear, height 0s;
            will-change: transform;
            transform: translate3d(0,0,0);
            &.active{
                height: 3rem;
                color: $red;
                font-size: to_rem(40px);
            }
        }
    }
    @include mobile_or_P{
        .arrow{
            transform: translateY(-50%);
            height: 2.5rem;
            background: url(../../assets/img/arrow_white.png) no-repeat center center / contain;
            &.left{
                /*right: 102%;*/
                right: calc(100% - 1.4rem);
                transform: translateY(-50%) scale(-1, 1);
            }
            &.right{
                /*left: 102%;*/
                left: calc(100% - 1.4rem);
                transform: translateY(-50%);
            }
        }
        .list{
            /*width: 24.2rem;*/
            .month{
                font-size: 0.9rem;
                color: $grey;
                &.active{
                    font-size: 3.25rem;
                    color: #fff;
                }
            }
        }
    }
</style>
